<template>
  <div class="page flex-col">
    <van-nav-bar
      title="卡券详情"
      left-arrow
      @click-left="$router.back()"
    />
     <div class="goods_info flex-col">
      <div class="goods_img">
        <img :src="goods_info.url"  alt="">
      </div>
      <div class="goods_title flex-row justify-between">
        <span class="text_3">{{ goods_info.title }}</span>
        <div class="text-wrapper_1">
          <span class="text_4">{{ goods_info.price }}</span>
          <span class="text_5">积分</span>
        </div>
      </div>
      <div class="goods_content"  v-html="goods_info.content">

      </div>
      <van-button 
        type="warning" 
        block 
        class="cart" 
        @click="handleExchange"
        :disabled="isExchanging || points < goods_info.price || goods_info.inventory_count<1"
      >
        {{ errorMessage }}
      </van-button>
  

     </div>
         
  </div>
</template>
<script>
export default {
  data() {
    return {
      points:0,
      isExchanging: false,
      errorMessage: '去兑换',
      goods_info: {
          // id: 1,
          // title: '猫眼电影兑换券一张',
          // price: 500,
          // status: '可兑换',
          // url: 'https://img1.360buyimg.com/n6/jfs/t1/101906/9/42686/32533/64afa88cFf3c57a5d/1f8e0a47c8f1a4cf.jpg',
          // content: '<p><strong><span class="" data-v-45fc3bf2="">兑换说明</span></strong></p><div class="text-wrapper_2" data-v-45fc3bf2=""><span class="text_7" data-v-45fc3bf2="">所有用户均可兑换，每人每</span><span class="text_8" data-v-45fc3bf2="">14</span><span class="text_9" data-v-45fc3bf2="">日限兑</span><span class="text_10" data-v-45fc3bf2="">15</span><span class="text_11" data-v-45fc3bf2="">张，累计限兑</span><span class="text_12" data-v-45fc3bf2="">123</span><span class="text_13" data-v-45fc3bf2="">张，兑换需花费</span><span class="text_14" data-v-45fc3bf2="">800</span><span class="text_15" data-v-45fc3bf2="">积分，券码不退、不换、不可兑现，数量有限，先到先得，</span></div><p><strong><span class="text_16" data-v-45fc3bf2="">兑换截止日期</span><span class="text_17" data-v-45fc3bf2="">2025-06-30&nbsp;23:59:59</span><span class="text_18" data-v-45fc3bf2="">使用说明</span></strong></p><div class="text-wrapper_3" data-v-45fc3bf2=""><span class="text_19" data-v-45fc3bf2="">1.</span><span class="text_20" data-v-45fc3bf2="">商品名称</span><span class="text_21" data-v-45fc3bf2="">:</span><span class="text_22" data-v-45fc3bf2="">喜马拉雅</span><span class="text_23" data-v-45fc3bf2="">FM</span><span class="text_24" data-v-45fc3bf2="">巅峰会员周卡</span><span class="paragraph_1" data-v-45fc3bf2=""><br data-v-45fc3bf2="" />2.&nbsp;</span><span class="text_25" data-v-45fc3bf2="">充值方式</span><span class="text_26" data-v-45fc3bf2="">:</span><span class="paragraph_2" data-v-45fc3bf2="">&nbsp;兑换码充值<br data-v-45fc3bf2="" /></span><span class="text_27" data-v-45fc3bf2="">3.</span><span class="paragraph_3" data-v-45fc3bf2="">&nbsp;为了避免造成不必要的损失，请在充值前仔细核对充值手机号。一旦支付成功，将无法退回或转充。<br data-v-45fc3bf2="" /></span><span class="text_28" data-v-45fc3bf2="">4.</span><span class="text_29" data-v-45fc3bf2="">具体会员权益详情在喜马拉雅</span><span class="text_30" data-v-45fc3bf2="">app</span><span class="text_31" data-v-45fc3bf2="">内会员界面查看会员权益，查看路径</span><span class="text_32" data-v-45fc3bf2="">:</span><span class="text_33" data-v-45fc3bf2="">打开喜马拉雅</span><span class="text_34" data-v-45fc3bf2="">app-</span><span class="text_35" data-v-45fc3bf2="">点击会员查看</span><span class="text_36" data-v-45fc3bf2="">vip</span><span class="text_37" data-v-45fc3bf2="">到账情况</span><span class="paragraph_4" data-v-45fc3bf2=""><br data-v-45fc3bf2="" />5.&nbsp;</span><span class="text_38" data-v-45fc3bf2="">会员权益以喜马拉雅</span><span class="text_39" data-v-45fc3bf2="">app</span><span class="text_40" data-v-45fc3bf2="">内描述或实际使用为准。</span></div>'
      }
    };
  },
  created() {
    this.fetchGoods();
  },
  methods: {
    async fetchGoods() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });
      try {
        const response = await this.$http.post(this.api+'/shop/goods/info', {
          id: this.$route.params.id
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        if (response.status == 200) {
  
        const data = response.data.data || {};
        console.log(data);
        this.goods_info = data.info || {};
        this.points = data.points || 0;
  
        if(data.info.inventory_count < 1) {
          this.errorMessage = '库存不足，无法兑换';
        }

       
        // this.goods = list.map(item => ({
        //   id: item.id,
        //   title: item.title || '未知商品',
        //   price: item.price || 0,
        //   status: (item.inventory_count > 0 && data.points>=item.price) ? '可兑换' : '不可兑换',
        //   url: item.url || ''
        // }));
        // this.points = data.points || 0;
         
        }else{
          this.$toast.clear();
          this.$toast(response.data.msg);
        }
        
      } catch (error) {
        console.error('请求失败:', error);
        this.$toast.clear();
      } finally {
        this.$toast.clear();
      }
    },
    handleExchange() {
      if (this.points < this.goods_info.price ) {
        this.errorMessage = '积分不足，无法兑换';
        return;
      }
      
      this.isExchanging = true;
      this.errorMessage = '';
      
      this.$toast.loading({
        message: '兑换中...',
        forbidClick: true,
        duration: 0
      });
      
      this.$http.post(this.api+'/shop/cart', {
        goods_id: this.goods_info.id
      })
      .then(response => {
        if(response.data.code == 200) {
          this.$toast.success('兑换成功');
          this.$router.push({
            name: 'exchange-success',
            params: {
              id: response.data.data.order_id
            }
          });
          this.isExchanging = false;
        } else {
          this.errorMessage = response.data.msg;
          this.isExchanging = true; // 保持禁用状态
        }
      })
      .catch(error => {
        this.errorMessage = error.response?.data?.msg || '兑换失败';
        this.isExchanging = true; // 保持禁用状态
      })
      .finally(() => {
        this.$toast.clear();
        if(!this.errorMessage) {
          this.isExchanging = false;
        }
      });
    }
  }
};
</script>
<style scoped lang="less" src="./assets/index.less" />